import { useRouteMatch } from 'react-router-dom';

import Signin, { SignInMode } from 'components/sign-in/Signin';

interface MatchParams {
  loginOrSignup: SignInMode;
}

const SigninRoute: React.FunctionComponent = () => {
  const match = useRouteMatch<MatchParams>();

  return <Signin postSigninPath="/" tab={match.params.loginOrSignup} hideHeader="onmobileonly" />;
};

export default SigninRoute;
